export default function VestGraphic({ className = "" }) {
  const vestPath =
    "M78 18 L100 44 L122 18 L150 26 C146 50 140 64 138 86 L146 204 L54 204 L62 86 C60 64 54 50 50 26 Z";
  return (
    <svg viewBox="0 0 200 220" className={className} role="img" aria-label="BuilderEDU student safety vest illustration" data-testid="vest-graphic">
      <defs>
        <clipPath id="vest-clip">
          <path d={vestPath} />
        </clipPath>
      </defs>

      {/* vest body — hi-vis yellow */}
      <path d={vestPath} fill="#D9E62B" stroke="#161F3D" strokeWidth="2.5" strokeLinejoin="round" />

      {/* reflective bands, clipped to the vest shape */}
      <g clipPath="url(#vest-clip)" fill="#B9BEC7">
        {/* vertical shoulder bands */}
        <rect x="72" y="14" width="13" height="86" transform="skewX(-3)" />
        <rect x="115" y="14" width="13" height="86" transform="skewX(3)" />
        {/* horizontal bands */}
        <rect x="40" y="98" width="120" height="15" />
        <rect x="40" y="150" width="120" height="15" />
      </g>

      {/* reflective band edges for the drafting feel */}
      <g clipPath="url(#vest-clip)" stroke="#161F3D" strokeWidth="1" opacity="0.35">
        <line x1="40" y1="98" x2="160" y2="98" />
        <line x1="40" y1="113" x2="160" y2="113" />
        <line x1="40" y1="150" x2="160" y2="150" />
        <line x1="40" y1="165" x2="160" y2="165" />
      </g>

      {/* zipper */}
      <line x1="100" y1="46" x2="100" y2="204" stroke="#161F3D" strokeWidth="2" strokeDasharray="4 3" />

      {/* BuilderEDU chest mark */}
      <text x="69" y="136" textAnchor="middle" fontFamily="Outfit, sans-serif" fontWeight="800" fontSize="10" fill="#161F3D" letterSpacing="0.5">
        BuilderEDU
      </text>
    </svg>
  );
}
